(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fc-announcement-ticker')) {
    customElements.define('fc-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const button = this.querySelector('button');
        button?.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
          button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
